import { withInstall, withNoopInstall } from '@bigin/utils'

import Breadcrumb from './src/breadcrumb.vue'
import BreadcrumbItem from './src/breadcrumb-item.vue'

export const BBreadcrumb = withInstall(Breadcrumb, {
  BreadcrumbItem,
})
export const BBreadcrumbItem = withNoopInstall(BreadcrumbItem)
export default BBreadcrumb

export * from './src/breadcrumb'
export * from './src/breadcrumb-item'
